var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-full mt-5"},[_c('ul',{staticClass:"w-full"},_vm._l((_vm.marks),function(item){return _c('li',{key:item.value,staticClass:"absolute whitespace-nowrap",style:({ left: item.left })},[_c('span',{staticClass:"text-small"},[_vm._v(_vm._s(item.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }